module.exports = __webpack_public_path__ + "img/grey.f64a3e31.png";